angular
	.module 'App.Directive.EpicConfiguration', []
	.directive 'epicConfiguration',
		->
			restrict: 'E';
			scope:
				defaultConfigs: '='
				modelName: '@'
				modelId: '@'
				oneAtATime: '@'
				filter: '=?'
			controller: 'EpicConfigurationController'
			controllerAs: 'epic'
			bindToController: true
			templateUrl: "@directive/epic-configuration/epic-configuration.view.html"

class EpicConfigurationController extends AbstractController
	@register angular.module 'App.Directive.EpicConfiguration'
	@inject '$scope',
		'MessageTerminal'
		'ConfigurationValueRepository'

	initialize: ->
		@oldSelectedItem = {}
		@oldOpenedItemId = -1

		@selectedItem = {}
		@searchTerm = ''

		@filteredConfigs = @getFilteredConfigs(@filter, @defaultConfigs)

		@configurationsTree = @getConfigurationTree(@filteredConfigs)

		@MessageTerminal.on @$scope, 'config-item-selected', (item) =>
			@searchTerm = ''
			@selectedItem = item

			if @oldOpenedItemId != -1
				@configurationsTree[@oldOpenedItemId].isOpen = true

			@oldOpenedItemId = -1

	getFilteredConfigs: (filter, configs) ->
		for config in configs
			# input[number] does not allows string as value, convert to int
			if config.value_type == 'IntegerConfigurationValueType'
				config.value = parseInt(config.value) || 0

			if config.value_type == 'ArrayConfigurationValueType'
				config.value = JSON.parse(config.value)

		if _.isEmpty filter
			return configs

		return _.filter configs, (config) ->
			isAllowed = true
			lowerIdentifier = config.identifier.toLowerCase()

			for prefix in filter
				isExclusion = prefix.indexOf('!') == 0
				normalizedPrefix = if isExclusion then prefix.substring(1).toLowerCase() else prefix.toLowerCase()

				if lowerIdentifier == normalizedPrefix || lowerIdentifier.indexOf(normalizedPrefix + '.') == 0
					isAllowed = !isExclusion

			return isAllowed

	search: ->
		term = @searchTerm.trim()

		if term.length > 0
			if @selectedItem.id != 0
				@oldSelectedItem = @selectedItem
				@oldOpenedItemId = _.findIndex @configurationsTree, {isOpen: true}

				if @oldOpenedItemId != -1
					@configurationsTree[@oldOpenedItemId].isOpen = false

			configs = []

			angular.forEach @filteredConfigs, (configuration) ->
				if configuration.identifier.toLowerCase().indexOf(term.toLowerCase()) != -1
					configs.push {
						name: configuration.identifier
						config: configuration
					}

			@selectedItem = {
				id: 0
				name: 'Search results'
				configs: configs
			}
		else if not _.isEmpty(@oldSelectedItem) and @oldSelectedItem.id != 0
			@MessageTerminal.publish 'config-item-selected', @oldSelectedItem

	getConfigurationTree: (configs) ->
		tree = []

		angular.forEach configs, (configModel, index) =>
			configNameParts = configModel.identifier.split('.')

			if configNameParts.length > 1
				configCategory = _.findWhere tree, {cat_name: configNameParts[0]}

				if angular.isUndefined configCategory
					configCategory =
						cat_name: configNameParts[0]
						items: [],
						isOpen: index == 0

					tree.push configCategory

				configSubObject = _.findWhere configCategory.items, {name: configNameParts[1]}

				if angular.isUndefined configSubObject
					configSubObject =
						name: configNameParts[1],
						configs: []

					configCategory.items.push configSubObject

				configStringArr = configModel.identifier.split(configNameParts[0] + '.' + configNameParts[1] + ".")

				if configStringArr.length != 0
					config = {name: configStringArr[1], config: configModel}

					@ConfigurationValueRepository.hideSensitiveInformation config.config

					configSubObject.configs.push config

		return _.sortBy tree, 'cat_name'
